import React from "react";
import '../../SbtierCSS/Footer.css';

function SbtierFooter(){
    return(
        <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2025 SatyaBalTech Semiconductor Pvt Ltd. All rights reserved. | Made with
          <span className="footer-heart"> &hearts; </span> in India.
        </p>
        {/* <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div> */}
        {/* <div className="logo-container-footer">
            <img src="/images/company_logo.png" alt="company Logo" className="company-logo" />  
        </div> */}
      </div>
    </footer>
    );
}

export default SbtierFooter;